import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import React__default, { useId } from 'react';
import { BaseLabel } from '../BaseLabel/BaseLabel.esm.js';
import baseLabelStyles from '../BaseLabel/BaseLabel.styles.esm.js';
import inlineMessageStyles from './InlineMessage.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

const InlineMessage = (props) => {
    const generatedId = useId();
    const { icon, label, variant = "error", disabled, className, onClick, id = generatedId, iconClass: customIconClass, labelClass: customLabelClass } = props, otherProps = __rest(props, ["icon", "label", "variant", "disabled", "className", "onClick", "id", "iconClass", "labelClass"]);
    // style variants
    const { container: containerClass, icon: iconClass, iconContainer: iconContainerClass, label: labelClass, } = inlineMessageStyles({
        variant,
    });
    const baseLabelClass = baseLabelStyles({});
    // eslint-disable-next-line react/jsx-no-useless-fragment
    const StyledIcon = React__default.cloneElement(icon !== null && icon !== void 0 ? icon : jsx(Fragment, {}), {
        className: cn(icon === null || icon === void 0 ? void 0 : icon.props.className, iconClass()),
    });
    return (jsxs("div", { className: containerClass({ class: className }), onClick: onClick, children: [jsx("span", { className: cn(iconContainerClass(), customIconClass), children: StyledIcon }), jsx(BaseLabel, Object.assign({ id: `${id}-${variant}`, className: cn(baseLabelClass, labelClass(), customLabelClass), disabled: disabled, "aria-live": "polite" }, otherProps, { children: label }))] }));
};

export { InlineMessage };
